import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { UnitViewComponent } from "./unit-view/unit-view.component";


const routes: Routes = [
    {
        path: '',
        data: {
            title: 'Unit',
          },
        component: UnitViewComponent,
    }
]

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class UnitRoutingModule { }